import { UserService } from '@ospace/auth'
import { CreateUserRequest } from '@ospace/schemas'
import { showNotification } from '@ospace/shared'
import { useMutation, useQueryClient } from 'react-query'

export const useCreateUserMutation = () => {
  const queryClient = useQueryClient()

  return useMutation((user: CreateUserRequest) => UserService.createUser(user), {
    onSuccess: (data) => {
      showNotification({
        message: 'You have successfully created the user.',
        type: 'success',
      })
      queryClient.invalidateQueries('users')
      queryClient.refetchQueries('users')
    },
    onError: (e: any) => {
      showNotification({
        message: e.message,
        type: 'error',
      })
    },
  })
}
